// Generated by BUCKLESCRIPT VERSION 2.2.3, PLEASE EDIT WITH CARE
'use strict';

var Css = require("bs-css/lib/js/src/Css.js");
var Link = require("./link");
var Theme = require("./theme");
var React = require("react");
var Js_exn = require("bs-platform/lib/js/js_exn.js");
var Caml_format = require("bs-platform/lib/js/caml_format.js");
var ReasonReact = require("reason-react/lib/js/src/ReasonReact.js");
var Lunch_iconSvg = require("./assets/lunch_icon.svg");
var Snack_iconSvg = require("./assets/snack_icon.svg");
var Caml_builtin_exceptions = require("bs-platform/lib/js/caml_builtin_exceptions.js");
var Dinner_iconSvg = require("./assets/dinner_icon.svg");
var Breakfast_iconSvg = require("./assets/breakfast_icon.svg");
var Mahlzeiten_patternPng = require("./assets/mahlzeiten_pattern.png");

var card = Css.style(/* :: */[
      Css.display(Css.flexBox),
      /* :: */[
        Css.fontSize(Theme.standardFontSize),
        /* [] */0
      ]
    ]);

var dashboard = Css.style(/* :: */[
      Css.backgroundImage(/* `url */[
            5843823,
            Mahlzeiten_patternPng
          ]),
      /* :: */[
        Css.textAlign(Css.center),
        /* :: */[
          Css.display(Css.flexBox),
          /* :: */[
            Css.flexDirection(Css.column),
            /* :: */[
              Css.alignItems(Css.center),
              /* :: */[
                Css.borderRadius(Css.px(8)),
                /* [] */0
              ]
            ]
          ]
        ]
      ]
    ]);

var flexList = Css.style(/* :: */[
      Css.textAlign(Css.center),
      /* :: */[
        Css.display(Css.flexBox),
        /* :: */[
          Css.flexDirection(Css.column),
          /* :: */[
            Css.alignItems(Css.center),
            /* [] */0
          ]
        ]
      ]
    ]);

var contentContainer = Css.style(/* :: */[
      Css.background(Css.white),
      /* :: */[
        Css.flexDirection(Css.column),
        /* :: */[
          Css.alignItems(Css.center),
          /* :: */[
            Css.width(/* `percent */[
                  -119887163,
                  100.0
                ]),
            /* :: */[
              Css.margin4(Css.px(14), Css.px(0), Css.px(10), Css.px(0)),
              /* :: */[
                Css.borderTopLeftRadius(Css.px(10)),
                /* :: */[
                  Css.borderTopRightRadius(Css.px(10)),
                  /* :: */[
                    Css.borderBottomLeftRadius(Css.px(10)),
                    /* :: */[
                      Css.borderBottomRightRadius(Css.px(10)),
                      /* :: */[
                        Css.boxShadow(/* Some */[Css.px(1)], /* Some */[Css.px(2)], /* Some */[Css.px(4)], /* None */0, /* None */0, Css.rgba(244, 44, 123, 0.25)),
                        /* [] */0
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ]);

var contentHeaderBox = Css.style(/* :: */[
      Css.position(/* relative */903134412),
      /* :: */[
        Css.flexDirection(Css.row),
        /* :: */[
          Css.alignItems(Css.center),
          /* :: */[
            Css.justifyContent(Css.center),
            /* :: */[
              Css.background(Css.hex("FFFAFA")),
              /* :: */[
                Css.borderBottom(Css.px(2), /* solid */12956715, /* `hex */[
                      5194459,
                      "FCEBEC"
                    ]),
                /* :: */[
                  Css.width(/* `percent */[
                        -119887163,
                        100.0
                      ]),
                  /* :: */[
                    Css.borderTopLeftRadius(Css.px(10)),
                    /* :: */[
                      Css.borderTopRightRadius(Css.px(10)),
                      /* [] */0
                    ]
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ]);

var contentHeaderMiddleEl = Css.style(/* :: */[
      Css.flexDirection(Css.column),
      /* :: */[
        Css.alignItems(Css.center),
        /* [] */0
      ]
    ]);

var infoHeaderH1 = Css.style(/* :: */[
      Css.lineHeight(1.1),
      /* :: */[
        Css.margin4(Css.px(18), Css.px(0), Css.px(0), Css.px(0)),
        /* :: */[
          Css.zIndex(2),
          /* [] */0
        ]
      ]
    ]);

var infoHeaderH3 = Css.style(/* :: */[
      Css.fontWeight(400),
      /* :: */[
        Css.fontSize(Css.px(18)),
        /* :: */[
          Css.margin4(Css.px(0), Css.px(0), Css.px(6), Css.px(0)),
          /* :: */[
            Css.zIndex(2),
            /* [] */0
          ]
        ]
      ]
    ]);

var horizonBox = Css.style(/* :: */[
      Css.textAlign(Css.center),
      /* :: */[
        Css.display(Css.flexBox),
        /* :: */[
          Css.flexDirection(Css.row),
          /* :: */[
            Css.alignItems(Css.center),
            /* [] */0
          ]
        ]
      ]
    ]);

var horizonBoxEl = Css.style(/* :: */[
      Css.margin4(Css.px(0), Css.px(8), Css.px(0), Css.px(8)),
      /* :: */[
        Css.fontSize(Css.px(24)),
        /* :: */[
          Css.fontWeight(700),
          /* :: */[
            Css.cursor(/* pointer */-786317123),
            /* [] */0
          ]
        ]
      ]
    ]);

var linkArrow = Css.style(/* :: */[
      Css.margin4(Css.px(0), Css.px(8), Css.px(6), Css.px(8)),
      /* :: */[
        Css.fontSize(Css.px(18)),
        /* :: */[
          Css.cursor(/* pointer */-786317123),
          /* :: */[
            Css.color(/* `hex */[
                  5194459,
                  "F66297"
                ]),
            /* :: */[
              Css.textDecoration(/* none */-922086728),
              /* [] */0
            ]
          ]
        ]
      ]
    ]);

var contentBox = Css.style(/* :: */[
      Css.textAlign(Css.center),
      /* :: */[
        Css.justifyContent(Css.center),
        /* :: */[
          Css.display(Css.flexBox),
          /* :: */[
            Css.flexDirection(Css.row),
            /* :: */[
              Css.flexWrap(Css.wrap),
              /* :: */[
                Css.alignItems(Css.center),
                /* :: */[
                  Css.boxSizing(/* borderBox */9307263),
                  /* :: */[
                    Css.padding4(Css.px(0), Css.px(12), Css.px(2), Css.px(12)),
                    /* [] */0
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ]);

var contentElBox = Css.style(/* :: */[
      Css.textAlign(Css.center),
      /* :: */[
        Css.margin4(Css.px(4), Css.px(2), Css.px(4), Css.px(2)),
        /* :: */[
          Css.cursor(/* pointer */-786317123),
          /* [] */0
        ]
      ]
    ]);

var contentEl = Css.style(/* :: */[
      Css.flexDirection(Css.column),
      /* :: */[
        Css.alignItems(Css.center),
        /* :: */[
          Css.textAlign(Css.center),
          /* :: */[
            Css.width(Css.px(130)),
            /* :: */[
              Css.height(Css.px(140)),
              /* :: */[
                Css.margin4(Css.px(4), Css.px(4), Css.px(4), Css.px(4)),
                /* [] */0
              ]
            ]
          ]
        ]
      ]
    ]);

var contentElInnerFrame = Css.style(/* :: */[
      Css.justifyContent(Css.center),
      /* :: */[
        Css.width(Css.px(100)),
        /* :: */[
          Css.height(Css.px(100)),
          /* :: */[
            Css.border(Css.px(2), /* solid */12956715, /* `hex */[
                  5194459,
                  "FFEEEF"
                ]),
            /* :: */[
              Css.borderRadius(Css.px(10)),
              /* :: */[
                Css.margin4(Css.px(4), Css.px(4), Css.px(4), Css.px(4)),
                /* [] */0
              ]
            ]
          ]
        ]
      ]
    ]);

var subText = Css.style(/* :: */[
      Css.color(/* `hex */[
            5194459,
            "FF328C"
          ]),
      /* :: */[
        Css.fontWeight(700),
        /* :: */[
          Css.alignSelf(Css.center),
          /* :: */[
            Css.fontSize(Css.px(16)),
            /* :: */[
              Css.margin2(Css.px(5), Css.px(0)),
              /* [] */0
            ]
          ]
        ]
      ]
    ]);

var inputHeader = Css.style(/* :: */[
      Css.marginBottom(Css.px(0)),
      /* :: */[
        Css.marginTop(Css.px(5)),
        /* :: */[
          Css.fontWeight(700),
          /* [] */0
        ]
      ]
    ]);

var inputField = Css.style(/* :: */[
      Css.margin4(Css.px(10), Css.px(0), Css.px(10), Css.px(0)),
      /* :: */[
        Css.padding2(Css.px(5), Css.px(5)),
        /* [] */0
      ]
    ]);

var someLink = Css.style(/* :: */[
      Css.fontSize(Theme.smallFontSize),
      /* :: */[
        Css.cursor(/* pointer */-786317123),
        /* :: */[
          Css.margin2(Css.px(5), Css.px(0)),
          /* [] */0
        ]
      ]
    ]);

function settingButton() {
  return Css.style(/* :: */[
              Css.minWidth(Css.em(12.0)),
              /* :: */[
                Css.fontSize(Css.px(18)),
                /* :: */[
                  Css.margin4(Css.px(22), Css.px(8), Css.px(40), Css.px(8)),
                  /* :: */[
                    Css.maxWidth(Css.em(13.0)),
                    Theme.greenButtonRaw
                  ]
                ]
              ]
            ]);
}

var centerIcon = Css.style(/* :: */[
      Css.margin2(Css.px(2), Css.px(6)),
      /* :: */[
        Css.transform(/* `scale */[
              -120664438,
              /* tuple */[
                1.0,
                1.0
              ]
            ]),
        /* :: */[
          Css.padding4(Css.px(2), Css.px(2), Css.px(2), Css.px(2)),
          /* [] */0
        ]
      ]
    ]);

var Styles = /* module */[
  /* card */card,
  /* dashboard */dashboard,
  /* flexList */flexList,
  /* contentContainer */contentContainer,
  /* contentHeaderBox */contentHeaderBox,
  /* contentHeaderMiddleEl */contentHeaderMiddleEl,
  /* infoHeaderH1 */infoHeaderH1,
  /* infoHeaderH3 */infoHeaderH3,
  /* horizonBox */horizonBox,
  /* horizonBoxEl */horizonBoxEl,
  /* linkArrow */linkArrow,
  /* contentBox */contentBox,
  /* contentElBox */contentElBox,
  /* contentEl */contentEl,
  /* contentElInnerFrame */contentElInnerFrame,
  /* subText */subText,
  /* inputHeader */inputHeader,
  /* inputField */inputField,
  /* someLink */someLink,
  /* settingButton */settingButton,
  /* centerIcon */centerIcon
];

function convToInt(theString) {
  try {
    return Caml_format.caml_int_of_string(theString);
  }
  catch (raw_exn){
    var exn = Js_exn.internalToOCamlException(raw_exn);
    if (exn[0] === Caml_builtin_exceptions.failure) {
      console.log("Issue with int conversion in food router");
      return 2;
    } else {
      throw exn;
    }
  }
}

function text(prim) {
  return prim;
}

var component = ReasonReact.statelessComponentWithRetainedProps("FoodDay");

function make(day, _) {
  var newrecord = component.slice();
  newrecord[/* willReceiveProps */3] = (function (self) {
      if (self[/* retainedProps */3] !== day) {
        console.log("day changed");
        return /* () */0;
      } else {
        return 0;
      }
    });
  newrecord[/* didMount */4] = (function () {
      return /* NoUpdate */0;
    });
  newrecord[/* render */9] = (function () {
      var previousDay = String(convToInt(day) - 1 | 0);
      var nextDay = String(convToInt(day) + 1 | 0);
      var actualDay = String(convToInt(day));
      return React.createElement("div", {
                  className: dashboard
                }, React.createElement("div", {
                      className: flexList
                    }, React.createElement("div", {
                          className: contentBox
                        }, React.createElement("div", {
                              className: contentContainer
                            }, React.createElement("div", {
                                  className: contentHeaderBox
                                }, React.createElement("div", {
                                      className: contentHeaderMiddleEl
                                    }, React.createElement("h1", {
                                          className: infoHeaderH1
                                        }, "Mahlzeiten"), React.createElement("div", {
                                          className: horizonBox
                                        }, ReasonReact.element(/* None */0, /* None */0, Link.make("/foodday/" + previousDay, "<", linkArrow, /* array */[])), React.createElement("h3", {
                                              className: infoHeaderH3
                                            }, "Tag " + actualDay), ReasonReact.element(/* None */0, /* None */0, Link.make("/foodday/" + nextDay, ">", linkArrow, /* array */[]))))), React.createElement("div", {
                                  className: contentBox
                                }, React.createElement("div", {
                                      className: contentElBox
                                    }, React.createElement("div", {
                                          className: contentEl,
                                          onClick: (function () {
                                              return ReasonReact.Router[/* push */0]("/foodday/" + (day + "/breakfast"));
                                            })
                                        }, React.createElement("div", {
                                              className: contentElInnerFrame
                                            }, React.createElement("img", {
                                                  className: centerIcon,
                                                  alt: "Breakfast",
                                                  src: Breakfast_iconSvg
                                                })), React.createElement("div", {
                                              className: subText
                                            }, "Frühstück")), React.createElement("div", {
                                          className: contentEl,
                                          onClick: (function () {
                                              return ReasonReact.Router[/* push */0]("/foodday/" + (day + "/snack"));
                                            })
                                        }, React.createElement("div", {
                                              className: contentElInnerFrame
                                            }, React.createElement("img", {
                                                  className: centerIcon,
                                                  alt: "Snack",
                                                  src: Snack_iconSvg
                                                })), React.createElement("div", {
                                              className: subText
                                            }, "Snack"))), React.createElement("div", {
                                      className: contentElBox
                                    }, React.createElement("div", {
                                          className: contentEl,
                                          onClick: (function () {
                                              return ReasonReact.Router[/* push */0]("/foodday/" + (day + "/lunch"));
                                            })
                                        }, React.createElement("div", {
                                              className: contentElInnerFrame
                                            }, React.createElement("img", {
                                                  className: centerIcon,
                                                  alt: "Lunch",
                                                  src: Lunch_iconSvg
                                                })), React.createElement("div", {
                                              className: subText
                                            }, "Mittagessen")), React.createElement("div", {
                                          className: contentEl,
                                          onClick: (function () {
                                              return ReasonReact.Router[/* push */0]("/foodday/" + (day + "/dinner"));
                                            })
                                        }, React.createElement("div", {
                                              className: contentElInnerFrame
                                            }, React.createElement("img", {
                                                  className: centerIcon,
                                                  alt: "Dinner",
                                                  src: Dinner_iconSvg
                                                })), React.createElement("div", {
                                              className: subText
                                            }, "Abendessen"))))))), React.createElement("button", {
                      className: settingButton(/* () */0),
                      onClick: (function () {
                          return ReasonReact.Router[/* push */0]("/dashboard");
                        })
                    }, "Dashboard"));
    });
  newrecord[/* retainedProps */11] = day;
  return newrecord;
}

exports.Styles = Styles;
exports.convToInt = convToInt;
exports.text = text;
exports.component = component;
exports.make = make;
/* card Not a pure module */



//////////////////
// WEBPACK FOOTER
// ./src/foodDay.re
// module id = 117
// module chunks = 0